import { IRequestInfo } from 'legacy/lut/classes/models/service'

import { IWsSectionSettings } from '../../../../services/partner360/sectionSettings/models/iWsSectionSettings'

export interface IClientSectionSettings extends IWsSectionSettings {}
export type TSectionSettingsValue = IClientSectionSettings[keyof IClientSectionSettings]
export type TSectionSettingsPatch = Partial<IClientSectionSettings> &
  Record<string, TSectionSettingsValue>

export const createSectionSettingsPatch = (
  sectionSettings: Record<string, TSectionSettingsValue>
): TSectionSettingsPatch => sectionSettings as TSectionSettingsPatch

export const getSectionSettingValue = (
  sectionSettings: Partial<IClientSectionSettings>,
  field: string
) => (sectionSettings as Record<string, TSectionSettingsValue | undefined>)[field]

export interface ISectionSettingsState extends IRequestInfo {
  settings: Partial<IClientSectionSettings>
}
